import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useUserLocale } from 'common/hooks/useUserLocale';
import { formatDateRange } from 'common/utils/dates/dateUtils';

import { OverridePeriod } from '../api-types';

type Props = {
  overrides: OverridePeriod[];
};

export const StatusPopoverContentSection = ({ overrides }: Props) => {
  const userLocale = useUserLocale();
  const format = useFormatMessage();

  return (
    <>
      {overrides.slice(0, 3).map((override) => {
        return (
          <div key={`${override.startDate}-${override.endDate}`}>
            <T.footnote>
              {formatDateRange(userLocale, {
                start: new Date(override.startDate),
                end: new Date(override.endDate),
              })}
            </T.footnote>
          </div>
        );
      })}
      {overrides.length > 3 && (
        <T.footnote>{format('forecasting.n_more', { count: overrides.length - 3 })}</T.footnote>
      )}
    </>
  );
};
